const About = () => {
  return (
    <section data-testid="about-section" id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-stretch">
          {/* Image */}
          <div className="relative overflow-hidden rounded-2xl h-full min-h-[400px]">
            <img
              data-testid="about-image"
              src="https://customer-assets.emergentagent.com/job_site-clone-quiz/artifacts/4g3g3dwm_New%20image.png"
              alt="Intelligence briefing presentation"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-helix-dark/20 to-transparent"></div>
          </div>

          {/* Content */}
          <div className="lg:pl-8 flex flex-col justify-between h-full">
            <h2 data-testid="about-title" className="text-4xl sm:text-5xl font-bold text-helix-dark mb-4">
              About Us
            </h2>
            <div className="flex-1 flex flex-col justify-between space-y-3 text-gray-600 leading-relaxed text-lg">
              <p>
                HelixAspire delivers real to near-time open source intelligence (OSINT) to support security and risk professionals at the tactical, operational, and strategic levels.
              </p>
              <p>
                We specialise in the continuous collection, analysis, and synthesis of open-source information into clear, structured intelligence outputs, enabling rapid, informed decision-making in dynamic environments. Our reporting is disciplined, concise, and directly aligned to operational relevance.
              </p>
              <p>
                From immediate incident awareness to broader threat trends and strategic risk positioning, our intelligence products are designed to support action at every level.
              </p>
              <p>
                Our intelligence dashboards provide a live, visual operating picture integrating real-time data, risk indicators, and location-specific insights into a single, intuitive interface. This enables users to quickly identify emerging issues, monitor trends, and prioritise response.
              </p>
              <p>
                We also provide outsourced intelligence and risk reporting services, allowing organisations to maintain high-quality, decision-ready outputs while focusing on core operational priorities.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
